export default "__VITE_ASSET__565032b1__"